import { getWaterTypes } from "@/service/waterType.service";
import { CascadeOption } from "@/types/genericData";
import { ImageLabelData } from "@/types/Image.type";
import { FilterImagesLabel } from "@/types/imageLabel.type";
import { WaterType } from "@/types/waterType.type";
import { Filter } from "@/types/filter.type";

//- TIPOLOGÍA DE AGUA

/**
 * Opciones Tipología de agua
 */
export const options_1: CascadeOption[] = [
  {
    label: "Válido",
    value: "valido",
    children: [
      {
        value: "determinado",
        label: "determinado",
      },
      {
        value: "indeterminado",
        label: "indeterminado ",
      },
    ],
  },
  { value: "invalido", label: "Inválido" },
  { value: "anomalia", label: "Anomalía" },
];

/**
 * Convertir una lista de tipos de agua en opciones
 * @param listWaterType
 * @returns
 */
export const convertWaterTypeToOptions = (listWaterType: WaterType[]): CascadeOption[] => {
  const clonedOptions = JSON.parse(JSON.stringify(options_1));
  if (listWaterType?.length > 0) {
    clonedOptions[0].children[0].children = listWaterType.map((type) => ({
      label: type.name,
      value: type.name,
    }));
  }
  return clonedOptions;
};
/**
 * Obtener todas las opciones para la tipología de agua
 * @param samplingPointId
 * @returns
 */
export const getOptions = async (samplingPointId: number): Promise<CascadeOption[]> => {
  const waterType = await getWaterTypes(samplingPointId);
  return convertWaterTypeToOptions(waterType);
};

//- Luminosidad
/**
 * Opciones luminosidad
 */
export const options_2: CascadeOption[] = [
  {
    value: "dia",
    label: "Día",
    children: [
      {
        value: "sol",
        label: "Sol",
      },
      {
        value: "sombra",
        label: "Sombra ",
      },
      {
        value: "solysombra",
        label: "Sol y Sombra",
      },
      {
        value: "nublado",
        label: "Nublado ",
      },
      {
        value: "lluvia",
        label: "Lluvia ",
      },
    ],
  },
  {
    value: "noche",
    label: "Noche",
    children: [
      {
        value: "normal",
        label: "Normal",
      },
      {
        value: "lluvia",
        label: "Lluvia ",
      },
    ],
  },
];

export const getFilterLabel = (filterImages: FilterImagesLabel, table: string) => {
  const filter: Filter = {};
  if (filterImages.label) {
    if (filterImages.label[filterImages.label.length - 1] === "valido") {
      filter.fields = {
        [`${table}.label`]: { operator: "not in", value: ["anomalia", "invalido"] },
      };
    } else if (filterImages.label[filterImages.label.length - 1] === "determinado") {
      filter.fields = {
        [`${table}.label`]: {
          operator: "not in",
          value: ["anomalia", "invalido", "indeterminado"],
        },
      };
    } else {
      filter.fields = {
        [`${table}.label`]: {
          operator: "equal",
          value: filterImages.label[filterImages.label.length - 1],
        },
      };
    }
  }
  return filter.fields;
};

export const getFilterLighting_condition = (filterImages: FilterImagesLabel, table: string) => {
  const filter: Filter = {};
  if (filterImages.lighting_condition) {
    filter.fields = {
      [`${table}.lighting_condition`]: {
        operator: "equal",
        value: filterImages.lighting_condition,
      },
    };
  }
  return filter.fields;
};
//- FILTROS

export const applyFilterBBDD = (filterImages: FilterImagesLabel, table: string): Filter => {
  const filter: Filter = {};

  if (filterImages.label && !filterImages.lighting_condition) {
    filter.fields = getFilterLabel(filterImages, table);
  }

  //- Luminsoidad
  if (filterImages.lighting_condition && !filterImages.label) {
    filter.fields = getFilterLighting_condition(filterImages, table);
  }

  // //- Combinación de filtros entre Tipología de agua y Luminsoidad
  if (filterImages.lighting_condition && filterImages.label) {
    const filterLabel = getFilterLabel(filterImages, table);
    const filterlighting_condition = getFilterLighting_condition(filterImages, table);
    if (filterLabel && filterlighting_condition) {
      filter.fields = {
        label: filterLabel[`${table}.label`],
        lighting_condition: filterlighting_condition[`${table}.lighting_condition`],
      };
    }
  }

  // //-Estimaciones
  if (filterImages.estimations) {
    if (filterImages.estimations === "with") {
      filter.fields = {
        "parameter.code": { operator: "equal", value: "TMOA" },
      };
    } else if (filterImages.estimations === "without") {
      filter.fields = {
        "imageEstimation.id": { operator: "is null", value: "" },
      };
    }
  }

  // //- Muestras asociadas
  if (filterImages.training_data) {
    if (filterImages.training_data === "with") {
      filter.fields = {
        "trainingRelations.id": { operator: "is not null", value: "" },
      };
    } else if (filterImages.training_data === "without") {
      filter.fields = {
        "trainingRelations.id": { operator: "is null", value: "" },
      };
    }
  }

  // //- Muestras asociadas TIPO
  if (filterImages.relationStatus) {
    filter.fields = {
      "trainingRelations.isClosest": { operator: "equal", value: filterImages.relationStatus },
    };
  }

  // Tipo (Orgánica / Sintética)
  if (filterImages.type && table == "imageLabel") {
    if (!filter.fields) filter.fields = {};
    filter.fields["trainingRelations.type"] = {
      operator: "equal",
      value: filterImages.type,
    };
  }

  //  Origen orgánico (solo si type = ORGANICO)
  if (filterImages.type === "ORGANICO" && filterImages.origin && table == "imageLabel") {
    if (!filter.fields) filter.fields = {};
    filter.fields["trainingData.origin"] = {
      operator: "equal",
      value: filterImages.origin,
    };
  }

  // Parámetro
  if (filterImages.parameter && table == "imageLabel") {
    if (!filter.fields) filter.fields = {};
    filter.fields["trainingData.codeParameter"] = {
      operator: "equal",
      value: filterImages.parameter,
    };
  }

  // Valores
  if (filterImages.values && table === "imageLabel") {
    if (!filter.fields) filter.fields = {};

    const val0 = filterImages.values[0];
    const val1 = filterImages.values[1];

    if (val0 != null && val1 != null) {
      // Si hay los dos valores
      filter.fields["trainingData.clean"] = {
        operator: "between",
        value: filterImages.values,
      };
    } else if (val0 != null) {
      // Solo el primer valor
      filter.fields["trainingData.clean"] = {
        operator: "equal",
        value: val0,
      };
    } else if (val1 != null) {
      // Solo el segundo valor
      filter.fields["trainingData.clean"] = {
        operator: "equal",
        value: val1,
      };
    }
  }

  return filter;
};
/**
 * -Filtrar por tipología
 * @param img
 */
const filterByTipologia = (img: ImageLabelData, filterImages: FilterImagesLabel): boolean => {
  if (img.imageLabel && img.imageLabel.label && filterImages.label) {
    if (filterImages.label[filterImages.label.length - 1] === "valido") {
      return img.imageLabel.label !== "anomalia" && img.imageLabel.label !== "invalido";
    } else if (filterImages.label[filterImages.label.length - 1] === "determinado") {
      return (
        img.imageLabel.label !== "anomalia" &&
        img.imageLabel.label !== "invalido" &&
        img.imageLabel?.label !== "indeterminado"
      );
    } else {
      return filterImages.label[filterImages.label.length - 1] === img.imageLabel?.label;
    }
  }
  return false;
};

export const applyFiltersImages = (
  images: ImageLabelData[],
  filterImages: FilterImagesLabel
): ImageLabelData[] => {
  return images.filter((img) => {
    if (filterImages.label && !filterImages.lighting_condition) {
      //- Tipología de agua
      return filterByTipologia(img, filterImages);
    }

    //- Luminsoidad
    if (filterImages.lighting_condition && !filterImages.label)
      return filterImages.lighting_condition == img.imageLabel?.lighting_condition;

    //- Combinación de filtros entre Tipología de agua y Luminsoidad
    if (filterImages.lighting_condition && filterImages.label)
      return (
        filterImages.lighting_condition === img.imageLabel?.lighting_condition &&
        filterByTipologia(img, filterImages)
      );

    //-Estimaciones
    if (filterImages.estimations) {
      if (filterImages.estimations === "with") {
        return img.nameTmoa ? true : false;
      } else if (filterImages.estimations === "without") {
        return !img.nameTmoa ? true : false;
      } else {
        console.log("Recuperar todas");
        return true;
      }
    }

    //- Muestras asociadas
    if (filterImages.training_data) {
      if (filterImages.training_data === "with") {
        return img.hasSamples;
      } else if (filterImages.training_data === "without") {
        return !img.hasSamples;
      } else {
        return true;
      }
    }

    return true;
  });
};
